import React from 'react';
import { useFetcher } from 'react-router-dom';
import { Controller, FieldValues, FormSubmitHandler, useForm } from 'react-hook-form';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import useDisplayError from '../../../hook/useDisplayError';
import CustomExportCard from './CustomExportCard';
import DateRangePicker from './DateRangePicker';
import styles from './GlobalStatsExport.module.scss';

function TurnoverExport() {
  const { t } = useTranslation('stats/customExport');
  const fetcher = useFetcher();
  useDisplayError(fetcher.data);
  const methods = useForm();

  const onSubmit: FormSubmitHandler<FieldValues> = ({ data }) => {
    fetcher.submit({ ...data, type: 'turnoverByArticleType' }, { method: 'post', encType: 'application/json' });

    methods.reset({}, { keepValues: true });
  };

  return (
    <CustomExportCard
      title={t('turnoverByArticleTypeExport.title')}
      onSubmit={onSubmit}
      fetcherData={fetcher.data}
      fetcherState={fetcher.state}
      text={t('turnoverByArticleTypeExport.advice')}
      {...methods}>
      <Controller
        name={'dates'}
        defaultValue={{ startDate: moment(), endDate: moment() }}
        render={({ field }) => {
          return (
            <div className={[styles.DateRangeBoxField, 'box-field'].join(' ')}>
              <span>{t('fields.period.label')}</span>
              <DateRangePicker
                startDate={field.value.startDate}
                endDate={field.value.endDate}
                onDatesChange={field.onChange}
              />
            </div>
          );
        }}
      />
    </CustomExportCard>
  );
}

export default TurnoverExport;
